module.exports = __webpack_public_path__ + "images/icon/share_primary_16-2f374748.svg";